import React from "react";
import Flex from "@irati/ui/src/Flex";
import Success from "@irati/ui/src/Success";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import { FormattedMessage } from "@irati/utils/lang";
var SuccessWithBackLink = function (_a) {
    var message = _a.message, backLink = _a.backLink, onClick = _a.onClick;
    return (React.createElement(Flex, { direction: "column", justifyContent: "center" },
        React.createElement(Success, { message: message }),
        React.createElement(Flex, { justifyContent: "center" },
            React.createElement(ButtonRouterLink, { to: backLink, onClick: onClick },
                React.createElement(FormattedMessage, { id: "admin.components.success.close" })))));
};
export default SuccessWithBackLink;
